import * as stylex from "@stylexjs/stylex";
import Link from "next/link";
import { FormattedMessage } from "react-intl";
import { useRTL } from "../../hooks";
import useLocale from "../../hooks/useLocale";
import * as M from "../../materials";
import { breakpoints, colors } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
import { O, pipe } from "../../prelude";
import { findArticleAliasRelaxed, foldRAliasArticle_ } from "../../routes";
const styles = {
    mark: {
        k1xSpc: "x78zum5",
        kaIpWk: "xgqmno8",
        kMwMTN: "x1vc0dw",
        kZKoxP: "xxk0z11",
        k7Eaqz: "x17y4j5z",
        kjj79g: "xl56j7k",
        kE3dHu: "x163pfp",
        kpe85a: "xy13l1i",
        k1ekBW: "xua3uq3",
        kIyJzY: "xx6bhzk",
        kGNEyG: "x6s0dn4",
        khDVqt: "xuxw1ft",
        kmzfnT: "x1klbbdq",
        kJuGS5: "x1277o0a",
        $$css: true
    },
    markLtr: {
        koQZXg: "xj3b58b x1cwa4bq",
        km5ZXQ: "x1yf7rl7",
        $$css: true
    },
    markRtl: {
        koQZXg: "xj3b58b",
        km5ZXQ: "x1yf7rl7 xsft18l",
        $$css: true
    },
    markArabic: {
        kGO01o: "xjkvuk6",
        $$css: true
    }
};
export const ThemeLabel = ({ theme, id })=>{
    const isRTL = useRTL();
    const locale = useLocale();
    const isArabic = locale === "ar";
    return pipe(findArticleAliasRelaxed(theme), O.fold(()=>null, (alias)=>{
        const { color, label } = foldRAliasArticle_({
            access: ()=>({
                    label: <FormattedMessage id="Access" defaultMessage="Access"/>,
                    color: M.q02Palette[6]
                }),
            equity: ()=>({
                    label: <FormattedMessage id="Equity" defaultMessage="Equity"/>,
                    color: M.q04Palette[7]
                }),
            learning: ()=>({
                    label: <FormattedMessage id="Learning" defaultMessage="Learning"/>,
                    color: M.q06Palette[6]
                }),
            trajectories: ()=>({
                    label: <FormattedMessage id="Trajectories" defaultMessage="Trajectories"/>,
                    color: M.q06Palette[6]
                }),
            quality: ()=>({
                    label: <FormattedMessage id="Quality" defaultMessage="Quality"/>,
                    color: M.q08Palette[6]
                }),
            finance: ()=>({
                    label: <FormattedMessage id="Finance – Governments and households" defaultMessage="Finance – Governments and households"/>,
                    color: M.q09Palette[7]
                }),
            "finance-aid": ()=>({
                    label: <FormattedMessage id="Finance – Aid" defaultMessage="Finance – Aid"/>,
                    color: M.q09Palette[7]
                })
        })(alias);
        return <Link href={`/articles/${alias}#${id || ""}`} {...{
            0: {
                className: "x15bdqvn x14yy4lh xljzpm6 x8x9d4c x1yf7rl7"
            },
            1: {
                className: "x15bdqvn x14yy4lh xljzpm6 xj3b58b xack27t"
            }
        }[!!isRTL << 0]}>
            <mark {...stylex.props(typography.table, styles.mark, isRTL ? styles.markRtl : styles.markLtr, isArabic && styles.markArabic)} style={{
            background: color
        }} color={color}>
              {label}
            </mark>
          </Link>;
    }));
};
